import { MinzeElement, EventListeners, Reactive, Attrs } from 'minze'
import { Locale } from '../../modules/locale'
import { Font } from '../../constants'
import { Callback } from '../../modules/callback'
import { IFlowSubscriber } from '../../modules/epflow'

Locale.getInstance().registerKeySet('fr', 'lvc-event-creation-debounce-popup', {
  tuxedo: 'Tuxedo',
  volum: 'Volum',
  scenePro: 'Scène Pro',
  ticketAcces: 'TicketAcces',
  ticketMaster: 'TicketMaster',
  newSince: '*NOUVEAU depuis septembre 2023',
  alreadyLoggedInTitle: 'Déjà connecté à ces plateformes? ',
  alreadyLoggedInContent: {
    long: "Si vous êtes déjà connecté.e à une de ces plateformes, alors vos événements sont déjà importés automatiquement sur <a href='https://www.lavitrine.com' >lavitrine.com</a>. Il est donc inutile de saisir vos événements. Vérifiez plutôt que toute l'information est à jour en effectuant une recherche sur <a href='/fr-search'>lavitrine.com/fr/recherche/</a>",
    short:
      "Si vous êtes déjà connecté.e à une de ces plateformes, alors vos expositions  sont déjà importées automatiquement sur <a href='lavitrine.com'>lavitrine.com</a>. Il est donc inutile de les saisir.",
  },
  cancel: 'Annuler',
  continue: 'Continuer',
})

Locale.getInstance().registerKeySet('en', 'lvc-event-creation-debounce-popup', {
  tuxedo: 'Tuxedo',
  volum: 'Volum',
  scenePro: 'Scène Pro',
  ticketAcces: 'TicketAcces',
  ticketMaster: 'TicketMaster',
  newSince: '*NEW since September 2023',
  alreadyLoggedInTitle: 'Already logged in to these platforms? ',
  alreadyLoggedInContent: {
    long: "If you are already logged in to one of these platforms, then your events are already automatically imported on <a href='https://lavitrine.com' >lavitrine.com</a>. It is therefore unnecessary to enter your events. Rather, check that all the information is up to date by doing a search on <a href='/search'>lavitrine.com/en/search/</a>",
    short:
      "If you are already logged in to one of these platforms, then your events are already automatically imported on <a href='https://lavitrine.com' >lavitrine.com</a>. It is therefore unnecessary to enter your events.",
  },
  cancel: 'Cancel',
  continue: 'Continue',
})

export interface LvcEventCreationDebouncePopup {
  onCancel?: string
  onContinue?: string
}

export class LvcEventCreationDebouncePopup
  extends MinzeElement
  implements MinzeElement, IFlowSubscriber
{
  reactive: Reactive = []
  attrs: Attrs = [['preset']]
  flowGroup: string = ''
  flowStep: string = ''

  public async serialize(): Promise<any> {
    return {}
  }

  public async deserialize(): Promise<any> {
    this.rerender()
  }

  public async validate(): Promise<boolean> {
    return true
  }

  onClickCancel(): void {
    Callback.call((this.onCancel ?? '') as string)
  }

  onClickContinue(): void {
    Callback.call((this.onContinue ?? '') as string)
  }

  html() {
    const alreadyLoggedInContent =
      this.preset === 'short'
        ? Locale.getKey('lvc-event-creation-debounce-popup.alreadyLoggedInContent.short')
        : Locale.getKey('lvc-event-creation-debounce-popup.alreadyLoggedInContent.long')

    return `
    <lvc-simple-modal id="modal" no-close-button="true">
      <div class="modal-content">
        <div class="provider-section">

          <div class="providers">
            <div class="platforms-container">
              <lvc-button enable-hover-box-shadow="true" id="tuxedo" class="platform-button" border-radius="4px" height="fit-content" width="fit-content" padding="10px 27px">
                ${Locale.getKey('lvc-event-creation-debounce-popup.tuxedo')}
              </lvc-button>
              <lvc-button enable-hover-box-shadow="true" id="volum" class="platform-button" border-radius="4px" height="fit-content" width="fit-content" padding="10px 27px">
                ${Locale.getKey('lvc-event-creation-debounce-popup.volum')}
              </lvc-button>
              <lvc-button enable-hover-box-shadow="true" id="scenePro" class="platform-button" border-radius="4px" height="fit-content" width="fit-content" padding="10px 27px">
                ${Locale.getKey('lvc-event-creation-debounce-popup.scenePro')}
              </lvc-button>
              <lvc-button enable-hover-box-shadow="true" id="ticketAcces" class="platform-button" border-radius="4px" height="fit-content" width="fit-content" padding="10px 27px">
                ${Locale.getKey('lvc-event-creation-debounce-popup.ticketAcces')}
              </lvc-button>
              <lvc-button enable-hover-box-shadow="true" id="ticketMaster" class="platform-button" border-radius="4px" height="fit-content" width="fit-content" padding="10px 27px">
                ${Locale.getKey('lvc-event-creation-debounce-popup.ticketMaster')}
              </lvc-button>
            </div>
          </div>
          <div class="provider-section-logo">
            <lvc-charlie-hands-together-full-body></lvc-charlie-hands-together-full-body>
          </div>
        </div>
        <div class="newSinceContainer">
          <lvc-text font-size="12px" font-weight="500" line-height="150%" class="newSinceText">
            ${Locale.getKey('lvc-event-creation-debounce-popup.newSince')}
          </lvc-text>
        </div>
        <div class="already-logged-in-container">
          <div class="already-logged-in-title-container">
            <lvc-text font-preset="titleMobileSmall" class="already-logged-in-title">
            ${Locale.getKey('lvc-event-creation-debounce-popup.alreadyLoggedInTitle')}
            </lvc-text>
          </div>
          <div class="already-logged-in-content-container">
            <lvc-text font-preset="small" class="already-logged-in-content" line-height="150%">
            ${alreadyLoggedInContent}            
            </lvc-text>
          </div>
          <div class="bottom-buttons-container">
            <lvc-button enable-hover-box-shadow="true" id="cancel-button" name="cancel-button" class="platform-button" border-radius="999px" height="fit-content" width="fit-content" border="1px solid #1E007D" color="#1E007D" padding="14px 80px" bg="transparent" font-size="14px">
            ${Locale.getKey('lvc-event-creation-debounce-popup.cancel')}
            </lvc-button>
            <lvc-button enable-hover-box-shadow="true" id="continue-button" name="continue-button" class="platform-button" border-radius="999px" height="fit-content" width="fit-content" padding="14px 80px" font-size="14px">
            ${Locale.getKey('lvc-event-creation-debounce-popup.continue')}
            </lvc-button>
          </div>
        </div>
      </div>
    </lvc-simple-modal>
    `
  }

  css = () => `
    :host {
      display: inline; 
    }

    .modal-content{
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 500px;
    }

    .copy-link-title {
      font-weight: ${Font.weight.medium};
      font-size: 17px;
      line-height: 120%;
      color: #1E007D;
      margin-top: 40px;
      margin-bottom: 8px;
    }

    .already-logged-in-title{
      text-transform: uppercase;
    }

    .already-logged-in-content-container{
      margin-top: 24px;
      margin-bottom: 60px;
    }

    .bottom-buttons-container{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .platforms-container {
      display: flex;
      flex-direction: column; /* Updated: Stack buttons vertically */
      gap: 40px;
    }

    .newSinceContainer{
      display: flex;
      justify-content: flex-end;
      margin-top: 15px;
      margin-bottom: 15px;
    }
    
    .copy-link-title.copied {
      color: #FF4600;
    }

    .copy-link-url {
      font-weight: ${Font.weight.medium};
      font-size: 14px;
      line-height: 150%;
      display: flex;
      align-items: center;
      color: #1E007D;
    }
    
    .provider-section {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-evenly;
      margin-top: 40px;
      margin-left: 0; 
    }

    .provider-section-logo {
      display: flex;
      align-items: center;
      flex-shrink: 0;

    }
    
    .providers {
      display: flex;
      flex-direction: row;
      gap: 8px;
    }
    
    .providers > div {
      display: flex;
      gap: 8px;
    }

    .provider-button {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-weight: ${Font.weight.medium};
      font-size: 14px;
      line-height: 150%;
      text-align: center;
      color: #1E007D;
      cursor: pointer;
    }

    .copy-link-body {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
      gap: 8px;

      height: 64px;

      /* Ciel */
      background: #BFF0FF;

      /* Inside auto layout */
      flex: none;
      order: 1;
      align-self: stretch;
      flex-grow: 0;

    }

    .copy-link-button {
      cursor: pointer;
    }

    .copy-link-text-button {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 13px 16px;
      gap: 8px;
      isolation: isolate;
      width: 73px;
      height: 40px;
      border: 1px solid #1E007D;
      border-radius: 999px;
      flex: none;
      order: 1;
      flex-grow: 0;
      font-family: ${Font.family};
      font-style: normal;
      font-weight: ${Font.weight.medium};
      font-size: 12px;
      line-height: 120%;
      font-feature-settings: 'tnum' on, 'lnum' on;
      color: #1E007D;
    }
    
    .provider-label {
      margin-top: 8px;
    }
    
    .provider-icon {
      width: 80px;
      height: 80px;
      border: 1px solid #1E007D;
      border-radius: 999px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .provider-icon {
      width: 80px;
      height: 80px;
      border: 1px solid #1E007D;
      border-radius: 999px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    @media screen and (max-width: 730px) {
      .copy-link-desktop {
        display: none; 
      }
    }
    @media screen and (min-width: 730px) {
      .copy-link-mobile {
        display: none; 
      }
    }
  `

  eventListeners: EventListeners = [
    ['[name="cancel-button"]', 'click', this.onClickCancel.bind(this)],
    ['[name="continue-button"]', 'click', this.onClickContinue.bind(this)],
  ]
}
